import phoneToE164 from "./phoneToE164";

const validatePhone = (phone: string): string | null => {
  if (!phone) {
    return "Telefone é obrigatório";
  }

  try {
    // Tenta converter para E.164 - se conseguir, é válido
    phoneToE164(phone);
    return null; // Válido
  } catch (error) {
    return error instanceof Error ? error.message : "Telefone inválido";
  }
};

export default validatePhone;
